
import { Upload } from "antd"
import { RcFile, UploadChangeParam, UploadFile } from "antd/es/upload";
import { useState } from "react";
import { getBase64 } from "../../utils/file.utils";
import { UploadOutlined } from "@ant-design/icons";
import { UploadListType } from "antd/es/upload/interface";

export const FileUploader = (props: {
    onChange?: (info: UploadChangeParam<UploadFile<string>>) => void;
})=>{

    const [file, setFile] = useState<string>("");
    const [listType, setListType] = useState<UploadListType>("picture-card")

    const beforeUpload = async (file:RcFile):Promise<boolean> => {
        await getBase64(file);
        return false;
    }

    const onChange = (info: UploadChangeParam<UploadFile<string>>) => {
        if(info.fileList.length == 0)
        {
            setListType("picture-card")
        } else {
            if (info.fileList[0]?.originFileObj) {
                getBase64((info.fileList as Array<any>)[0].originFileObj as Blob).then(x => x?.toString() ?? "").then((dataUrl:string)=>{
                    setFile(dataUrl);
                    setListType("text")
                    if(props.onChange)
                    {
                        info.file.response = dataUrl;
                        props.onChange(info);
                    }
                });
            }
        }
    };
    
    return (
        <>
        <Upload 
            multiple={false}
            maxCount={1}
            listType={listType}
            onChange={onChange}
            beforeUpload={beforeUpload}
            >
                <UploadOutlined />
        </Upload>
        </>
    )
}